import {sortFunctionByID, localizeNumber, normalizeSelectInput, toNumber } from "../../../../helpers";
import ibsStore from "../../../Stores/IbsSurveyStore"
import store from "../../../Stores/SurveyStore"
import { SelectCombosIBS, NumberFormat } from "../../../../Enums/constants";
import { columnCalculation } from "../../../../Helpers/TableCalculationHelper";
import { renderDeleteIconBtn, isNumField } from "../../../../Helpers/TableHelper";
import { saveValueNew } from "../../../../control";
import { mapToDropdownOption, addNewBenchmark } from "../../../../ibsHelper";
import { getSurveyResponseValue } from "../../../../Helpers/General/SurveyResponsesHelper";
import { formatNumber } from "../../../../Helpers/General/FormatHelper";

export function createBenchmarkData(props, referenceToTable, listOfHeaderRows, dataObj) {
    let rowCount = -1;
    listOfHeaderRows = [] //keep track of what rows are headers

    let uniqueCategoryNames = [];
    
    if (ibsStore.allTableResponses[props.tableName]) {
        uniqueCategoryNames = [...new Set(ibsStore.allTableResponses[props.tableName].map(item => item.AssetClassCategoryName))]; // [ 'A', 'B']
    } else {
        return;
    }

    for (const categoryName of uniqueCategoryNames) {
        let categoryHeaderRow;
        if (store.questionMode) {
            categoryHeaderRow = { AssetClassCategoryName: "AssetClassCategoryName", AssetClassName: null, PolicyWeightPercent: null, PolicyBenchmarkName: null, PolicyReturnPercent: null, AssetMixPercent: null, ExternalManagerCount: null, IsLiabilityHedging: null, __children: null };
        } else {
            categoryHeaderRow = { AssetClassCategoryName: categoryName, AssetClassName: null, PolicyWeightPercent: null, PolicyBenchmarkName: null, PolicyReturnPercent: null, AssetMixPercent: null, ExternalManagerCount: null, IsLiabilityHedging: null, RowID: null, __children: null };
        }
        referenceToTable.push(categoryHeaderRow)
        rowCount = rowCount + 1
        listOfHeaderRows.push(rowCount)

        let benchmarkDataForCategory = undefined;

        benchmarkDataForCategory = ibsStore.allTableResponses[props.tableName]
            .filter(row => row.AssetClassCategoryName === categoryName)
            .sort(sortFunctionByID("AssetClassName"));

        let childrenForCategory = [];
        for (const benchmarkDatum of benchmarkDataForCategory) {
            let child = {}
            if (!store.questionMode) {
                child =
                {
                    __AssetClassCategoryName: categoryName,
                    AssetClassCategoryName: "",
                    AssetClassName: benchmarkDatum.AssetClassName,
                    PolicyWeightPercent: localizeNumber(benchmarkDatum.PolicyWeightPercent),
                    PolicyBenchmarkName: benchmarkDatum.PolicyBenchmarkName,
                    PolicyReturnPercent: localizeNumber(benchmarkDatum.PolicyReturnPercent),
                    PolicyReturnPercentMarch: localizeNumber(benchmarkDatum.PolicyReturnPercentMarch),
                    placeholder1: '',
                    AssetMixPercent: localizeNumber(benchmarkDatum.AssetMixPercent),
                    ExternalManagerCount: benchmarkDatum.ExternalManagerCount,
                    IsLiabilityHedging: mapToDropdownOption(benchmarkDatum.IsLiabilityHedging, SelectCombosIBS.LIABILITY_HEDGING),
                    RowID: benchmarkDatum.RowID,
                    del: "",
                }
            }

            rowCount = rowCount + 1
            childrenForCategory.push(child)
            referenceToTable.push(child)
        }

        categoryHeaderRow['__children'] = childrenForCategory
        dataObj.push(categoryHeaderRow)
    }

    let totalRow = {
        AssetClassCategoryName: "Total",
        AssetClassName: "",
        PolicyWeightPercent: formatNumber(NumberFormat.PERCENTAGE, columnCalculation("PolicyWeightPercent", true, props)),
        PolicyBenchmarkName: "",
        PolicyReturnPercent: "",
        PolicyReturnPercentMarch: "",
        AssetMixPercent: formatNumber(NumberFormat.PERCENTAGE, columnCalculation("AssetMixPercent", true, props)),
        ExternalManagerCount: "",
        RowID: "Total",
        test1: "",
        ReturnPercent: null,
        Holdings: null,
        __children: null
    }


    listOfHeaderRows.push(rowCount + 1)
    dataObj.push(totalRow)
    referenceToTable.push(totalRow)
    return [dataObj, listOfHeaderRows];
}


export function benchmarkDeletable (rowID) {
    //find row in benchmarks data
    let matchBM = ibsStore.allTableResponses["Benchmark"].findIndex(element => {
        return (element.RowID == rowID)
    })
    let benchmarkAssetID = ibsStore.allTableResponses["Benchmark"][matchBM]?.AssetClassID

    let existsInAssets;
    if (ibsStore.checkMandateLevel == 1) {
        existsInAssets = ibsStore.mandateData.findIndex(element => {
            return (element.assetClassID == benchmarkAssetID)
        })
    } else {
        existsInAssets = ibsStore.allTableResponses["combinedAssets"].findIndex(element => {
            return (element.AssetClassID == benchmarkAssetID)
        })
    }


    if (existsInAssets > -1) {
        return false
    }
    return true

}

export function handleBenchmarkData(props, referenceToTable, listOfHeaderRows, dataObj) {
    let benchmarkReturnObj = createBenchmarkData(props, referenceToTable, listOfHeaderRows, dataObj)
    let data = benchmarkReturnObj[0]
    let headers = benchmarkReturnObj[1]
    return [data, referenceToTable, headers]
}


export function benchmarkCellRenderer(instance, td, row, col, prop, value, cellProperties, referenceToTable, props, listOfHeaderRows) {
    if (prop === "del" && listOfHeaderRows.includes(row) && !benchmarkDeletable(referenceToTable[row].RowID)) {
        td.className = td.innerHTML = "";
        td.className = td.className + "delColHeaderRow"
    }
    if (prop === "del" && !listOfHeaderRows.includes(row) && td.id !== "undefined" && benchmarkDeletable(referenceToTable[row].RowID)) {
        renderDeleteIconBtn(td, row, props, referenceToTable)
    }
    //these columns should be read only
    if (col === 0 || col === 1) {
        td.className = td.className + " readOnlyCell"
    }
    return cellProperties

}


export function beforeKeyDownBenchmark(e, editor) {
    try {
        // Prevent people from entering floats, chars in ExternalManagerCount
        if (editor.prop === "ExternalManagerCount" &&
            (!/[0-9]/.test(e.key) && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Backspace')) {
            e.preventDefault();
        }
    }
    catch { }
}

export function handleHOTChangeBenchmark(table, rowNum, qId, oldValue, newValue, props, referenceToTable) {
    if (rowNum !== undefined && rowNum !== null
        && qId !== undefined && qId !== null
        && newValue != oldValue
        && newValue !== 'undefined') { // TODO something weird happens when this is changed to newValue !== oldValue

        let normalizedNewValue = newValue;

        if (isNumField(table, qId, props)) {
            normalizedNewValue = toNumber(newValue);
            if (Number.isNaN(normalizedNewValue)) {
                // It's a number field, but newValue is not a number
                // just save an empty value
                normalizedNewValue = null;
            }
        }
        if (qId === "IsLiabilityHedging") {
            normalizedNewValue = normalizeSelectInput(newValue, SelectCombosIBS.LIABILITY_HEDGING)
        }
        let rowId, result;
        rowId = referenceToTable[rowNum].RowID //the rowId 
        result = ibsStore.allTableResponses[props.tableName].findIndex(row => row.RowID === rowId); //where it is saved on frontend

        ibsStore.allTableResponses[props.tableName][result][qId] = normalizedNewValue;

        let rulesSet = saveValueNew(qId, normalizedNewValue, { tableName: props.tableName, rowId })

    }
}

export function AddEmptyBenchmarkRow() {
    store.addingBenchmark = true;
    addNewBenchmark()
}


export function getHiddenBenchmarkColumns() {
    const hiddenColumns = [];
    const COLUMN_INDEX = {
        POLICY_RETURN_PERCENT_MARCH: 5,
        ASSET_MIX_PERCENT: 6,
        IS_LIABILITY_HEDGING: 8,
    };

    hiddenColumns.push(COLUMN_INDEX.POLICY_RETURN_PERCENT_MARCH);       // Always hide March policy column (deprecated)

    const assetsDifferFromExposures = ibsStore.allResponses?.["AssetsDifferFromExposures"] == 1;
    if (!assetsDifferFromExposures) {
        hiddenColumns.push(COLUMN_INDEX.ASSET_MIX_PERCENT);
    }

    const includeNotCoreAssets = getSurveyResponseValue("IncludeNotCoreAssets");
    if (includeNotCoreAssets == 0) {
        hiddenColumns.push(COLUMN_INDEX.IS_LIABILITY_HEDGING);
    }

    return hiddenColumns;
}
